export const CrispChat = {
  openChatBoxMessage: 'Ouvrir la boîte de chat en direct',
  chat_with_us: 'Discutez avec nous',
};
